import { get, post } from './api_base';

// get the current agent's info
export const agentGetInfo = async (reag_owner_user) => {
  const path = `reagent/${reag_owner_user}`;

  try {
    const getRequest = await get(path);
    return getRequest;
  } catch(err) {
    console.log('Error getting /reagent: ', err);
    return err;
  }
}

// get a reagent's clients
export const agentGetClients = async (reag_owner_user) => {
  const path = `reagent/clients/${reag_owner_user}`;

  try {
    const getRequest = await get(path);
    return getRequest;
  } catch(err) {
    console.log('Error getting /reagent/clients: ', err);
    return err;
  }
}